import { FC } from 'react';
import DvConstraintsComponent from 'components/main/DvConstraints';

const DvConstraints: FC = () => {
  return <DvConstraintsComponent />;
};

export default DvConstraints;
